import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Sæt nye ordrer på pause',
  sections: {
    pause_orders: {
      title: 'Hvor længe er du ikke tilgængelig?',
      description: 'Vi informerer kunderne om, at du ikke tager imod nye ordrer lige nu',
    },
    order_methods: {
      title: 'Mine ordremetoder',
      description: 'Slå metoder til eller fra, så kunderne kan bestille hos dig',
    },
    delivery_mode: {
      title: 'Leveringsmetoder',
      description: 'Skift mellem dine egne og vores chauffører',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min.',
        '15_min': '15 min.',
        '20_min': '20 min.',
        '25_min': '25 min.',
        '1_hour': '1 time',
        '2_hours': '2 timer',
        rest_of_day: 'Resten af dagen',
      },
    },
    has_standalone_delivery: {
      label: 'Mine chauffører',
    },
    has_external_delivery: {
      label: '{{provider}}-chaufførnetværk',
    },
  },
  labels: {
    delivery_orders_off: 'Leveringsordrer fra',
    delivery_orders_on: 'Leveringsordrer til',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: 'Er du sikker på, at du vil aktivere leveringsordrer?',
        description: '',
      },
      [false]: {
        title: 'Er du sikker på, at du vil deaktivere leveringsordrer?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: 'Er du sikker på, at du vil skifte til dine egne chauffører?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: 'Er du sikker på, at du vil skifte til {{provider}}-chauffører?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Bekræft',
    cancel: 'Annuller',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
